(() => {
  // Mask only the initial AZN price flash while the BUCKS widget initializes.
  (() => {
    const root = document.documentElement;
    if (!/^az(?:-|$)/i.test(root.lang || '')) return;
    let preferred = '';
    try { preferred = localStorage.getItem('en-bucks-display-code') || ''; } catch (error) {}
    if (preferred && preferred !== 'AZN') return;

    const className = 'en-bucks-boot-pending';
    root.classList.add(className);
    let observer;
    let timeout;
    let finished = false;
    const currencyClicked = event => {
      const option = event.target.closest?.('.buckscc-currency-wrapper .buckscc-select-options li[rel]');
      if (option && option.getAttribute('rel') !== 'AZN') release();
    };
    const release = () => {
      if (finished) return;
      finished = true;
      root.classList.remove(className);
      observer?.disconnect();
      clearTimeout(timeout);
      document.removeEventListener('click', currencyClicked, true);
    };
    const check = () => {
      const selected = document.querySelector('.buckscc-currency-wrapper .bucks-selected')?.textContent?.trim();
      if (selected !== 'AZN') return;
      if (!document.querySelector('.money:not([bucks-currency="AZN"])')) release();
    };
    document.addEventListener('click', currencyClicked, true);
    observer = new MutationObserver(check);
    observer.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'bucks-currency'] });
    // Fail open: third-party errors must never hide prices indefinitely.
    timeout = setTimeout(release, 12000);
    check();
  })();

  const ROOT = 'en-bucks-ready';
  let pending = false;
  let wiredControl = null;
  let wiredWidget = null;

  function render() {
    pending = false;
    const header = document.querySelector('.euronavigate-header');
    const original = document.querySelector('.section-announcement-bar .localization-wrapper .localization-form__select');
    const widget = document.querySelector('.buckscc-currency-wrapper');
    const control = widget?.querySelector('.buckscc-select-styled');
    if (!header || !original || !widget || !control) return;

    const mobile = window.matchMedia('(width < 990px)').matches;
    const slot = document.querySelector(mobile ? '.en-currency-shell--mobile' : '.en-currency-shell--desktop');
    if (!slot) return;
    const bounds = slot.getBoundingClientRect();
    const offscreen = bounds.width < 1 || bounds.height < 1 || bounds.bottom < 0 ||
      bounds.top >= innerHeight || bounds.right <= 0 || bounds.left >= innerWidth;
    const compactWidth = bounds.width;
    const compactLeft = bounds.left;
    widget.style.setProperty('--en-bucks-x', compactLeft + 'px');
    widget.style.setProperty('--en-bucks-y', bounds.top + 'px');
    widget.style.setProperty('--en-bucks-w', compactWidth + 'px');
    widget.classList.add('en-bucks-mounted');
    widget.classList.toggle('en-bucks-offscreen', offscreen);

    if (!control.querySelector('.en-bucks-globe')) {
      const svg = original.querySelector('.icon-localization')?.cloneNode(true);
      if (svg) {
        svg.classList.add('en-bucks-globe');
        svg.setAttribute('aria-hidden', 'true');
        control.prepend(svg);
      }
    }
    if (!control.querySelector('.en-bucks-caret')) {
      const svg = original.querySelector('.icon-caret')?.cloneNode(true);
      if (svg) {
        svg.classList.add('en-bucks-caret');
        svg.setAttribute('aria-hidden', 'true');
        control.append(svg);
      }
    }

    if (widget) {
      // BUCKS may nest the selected flag inside the hidden globe on any viewport.
      // Move that existing flag back into the visible mobile control.
      const hiddenFlag = control.querySelector('.en-bucks-globe .flagWrapper');
      if (hiddenFlag?.querySelector('.hxoFlag')) {
        // Only the newest selected-currency flag should remain visible.
        control.querySelectorAll(':scope > .flagWrapper').forEach(node => {
          if (node.querySelector('.hxoFlag')) node.remove();
        });
        control.insertBefore(hiddenFlag, control.querySelector('.bucks-selected'));
      }
      control.querySelectorAll(':scope > .flagWrapper').forEach(node => {
        node.classList.toggle('en-bucks-flag-text', !node.querySelector('.hxoFlag'));
      });
    }

    if (wiredControl !== control) {
      wiredControl = control;
      control.setAttribute('role', 'button');
      control.setAttribute('aria-label', 'Select display currency');
      control.tabIndex = 0;
      control.setAttribute('aria-expanded', 'false');
      control.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          control.click();
        }
      });
      control.addEventListener('click', () => {
        const list = widget.querySelector('.buckscc-select-options');
        if (!list) return;
        const open = list.classList.toggle('en-bucks-open');
        control.setAttribute('aria-expanded', String(open));
      });
    }
    if (wiredWidget !== widget) {
      wiredWidget = widget;
      widget.addEventListener('click', event => {
        const option = event.target.closest('.buckscc-select-options li');
        if (!option) return;
        widget.querySelector('.buckscc-select-options')?.classList.remove('en-bucks-open');
        control.setAttribute('aria-expanded', 'false');
        const code = option.getAttribute('rel') || option.id;
        if (code) {
          [100, 450].forEach(ms => setTimeout(() => {
            const label = widget.querySelector('.bucks-selected');
            if (label) label.textContent = code;
            if (/^(AZN|USD|EUR|GBP|CAD)$/.test(code)) {
              try { localStorage.setItem('en-bucks-display-code', code); } catch (e) {}
            }
          }, ms));
        }
      });
    }
    const selectedCode = widget.querySelector('.bucks-selected')?.textContent?.trim();
    if (/^(AZN|USD|EUR|GBP|CAD)$/.test(selectedCode || '')) {
      try {
        if (localStorage.getItem('en-bucks-display-code') !== selectedCode)
          localStorage.setItem('en-bucks-display-code', selectedCode);
      } catch (e) {}
    }
    document.documentElement.classList.add(ROOT);
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(render);
  }

  function start() {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('click', event => {
      const widget = document.querySelector('.buckscc-currency-wrapper');
      if (!widget || widget.contains(event.target)) return;
      widget.querySelector('.buckscc-select-options')?.classList.remove('en-bucks-open');
      widget.querySelector('.buckscc-select-styled')?.setAttribute('aria-expanded', 'false');
    });
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
})();

